var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "273px",
    height: "264px",
    viewBox: "0 0 273 264",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Request-an-Account-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "U.M_1.1_-Request-access-_info_where-is-my-CAN",
    transform: "translate(-43.000000, -418.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(44.000000, 419.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 0.84,
    points: "0 0 261.24 0 261.24 208.987748 176.1912 253.024994 103.8 228.3 0 261.6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 208.32,
    y: 47.88,
    width: 37.8,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 208.32,
    y: 57.12,
    width: 33.6,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 100.8,
    width: 171.36,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 110.04,
    width: 171.36,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 47.88,
    width: 57.12,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 57.12,
    width: 57.12,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 119.28,
    width: 171.36,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 128.52,
    width: 171.36,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 137.76,
    width: 171.36,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 147,
    width: 171.36,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 156.24,
    width: 171.36,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 20.16,
    y: 165.48,
    width: 144.48,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 208.32,
    y: 68.04,
    width: 37.8,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 208.32,
    y: 77.28,
    width: 30.24,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 208.32,
    y: 86.52,
    width: 33.6,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 208.32,
    y: 95.76,
    width: 30.24,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 208.32,
    y: 106.68,
    width: 33.6,
    height: 5.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 208.32,
    y: 115.92,
    width: 26.88,
    height: 5.04
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#29AAFF",
    strokeWidth: 1.68,
    cx: 231.84,
    cy: 62.16,
    r: 38.64
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCan);
export default __webpack_public_path__ + "static/media/CAN.b45bcab81fe3359757f0aa4b6754cf8b.svg";
export { ForwardRef as ReactComponent };